import {
  Component, ContentChildren, Directive, EventEmitter,
  Input, Output, QueryList,
} from '@angular/core';
import {CloNotificationItem} from '..';

@Directive({selector: 'clo-mobileNav-item'})
export class MobileNavItem {
  @Input() title: string;
  @Input() routerLink: string;

  @Output() onClick = new EventEmitter();


}

/**
 * The Mobile Navigation [copy].
 */
@Component({
  selector: 'clo-mobile-nav',
  templateUrl: './mobile-nav.html',
  styleUrls: ['./mobile-nav.css']
})
export class MobileNavigationMenu {

  /**
   * type of nav: `back`, `close`
   */
  @Input() iconImageType: string;

  /**
   * The router link associated with the icon in the nav
   */
  @Input() navigationLink: string;


  /**
   * The heading in the nav
   */
  @Input() heading: string;

  /**
   * The sub heading
   */
  @Input() subHeading: string;

  @Output() onClick = new EventEmitter<any>();

  @ContentChildren(MobileNavItem) kebabItems: QueryList<MobileNavItem>;

  imageTypes = {
    'back': 'backward-arrow-icon',
    'close': 'close-icon'
  };
  image: string;
  constructor() {
  }

  emitClickEvent($event) {
    console.log('hello?');
    this.onClick.emit($event);
  }

}
